<template>
    <Card :title="$t('labels.edit_tag')">
        <div class="card-body">
            <FormGroup :label="$t('labels.name')" >
                <Input v-model="tagName" />
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" :style="{gap: '0.5rem'}">
            <AppButton color="light" @click="removeTag">
                {{ $t('buttons.delete') }}
            </AppButton>
            <AppButton @click="updateTag" color="indigo">
                {{ $t("buttons.edit") }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";

export default {
    name: "EditTagsCard",
    components: {
        Card, FormGroup, Input, AppButton
    },
    data() {
        return {
            tagName: ''
        }
    },
    methods: {
        fetchTag() {
            httpClient.get(`/integration-product-tags/${this.$route.params.integrationProductTagUuid}`)
                .then(response => {
                    this.tagName = response.data.data.name;
                });
        },
        updateTag() {
            httpClient.put(`/integration-product-tags/${this.$route.params.integrationProductTagUuid}`, {
                name: this.tagName
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        },
        removeTag() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete'), () => {
                httpClient.delete(`/integration-product-tags/${this.$route.params.integrationProductTagUuid}`)
                    .then(() => {
                        this.$router.push({name: 'TagsCard'});
                    });
            });
        }
    },
    mounted() {
        this.fetchTag();
    }
}
</script>